import { Link } from 'react-router-dom'
import Header from'../Component/Header';
import Footer from'../Component/Footer';  
import { getPrincipalMessage } from "../Service/Api"; 
import LazyLoad from 'react-lazyload';
import { useState ,useEffect } from 'react';
function VicePrincipal() { 
  useEffect(() => {
    document.title = 'Vice Principal Message -  Mercy Memorial School, Kanpur';  
}, []); 
const [data, setData] = useState([]);
useEffect(() => {
 const fetchData = async () => {
   try {
     const msgdata = await getPrincipalMessage();
    const data = msgdata.filter((item) => item.category === "Vice Principal");
    
     setData(data);
   } catch (error) {
     console.error("Error fetching online registration data:", error);
   }  
 };
 fetchData();
}, []);
  return (
    <>   
      <Header />
      <div className="sliderbg"></div>
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="breadcrumbli">
                <li><Link to="/"> Home </Link></li>
                <li>About Us</li>
                <li>Vice Principal's Message</li>
              </ul>
            </div> 
            <div className="col-lg-12">
              <h2 className="innerheading">Vice Principal Message</h2>
            </div>
          </div> 
          <div className="row">
          {data.length > 0 && (
            <div className="clearfix">
               <LazyLoad> <img 
                src={`https://webapi.entab.info/api/image/${data[0].attachments}`} 
                className="img-fluid col-sm-12 col-md-4 float-md-end mb-3 msgimg" 
                alt={data[0].name || 'Image'}
              /></LazyLoad>
              <p><div dangerouslySetInnerHTML={{ __html: data[0].message }} /></p> 
              <p className="name">
                {data[0].name}<span> {data[0].category} </span>
              </p>
            </div>
          )}

          {data.length === 0  && (
            <div className="clearfix">
               <LazyLoad> <img 
                src="https://webapi.entab.info/api/image/MMSKN/public/Images/dummy.jpg" 
                className="img-fluid col-sm-12 col-md-4 float-md-end mb-3 msgimg" 
                alt=""
              /></LazyLoad>
              <p>"When educating the minds of our youth, we must not forget to educate their hearts". We focus on discovering, developing and drawing out the hidden talents and the magic lying dormant inside all of our students. From academics to co-curricular activities, perseverance and a never-say-die spirit are entrenched in the heart of every student not only making them good students but brilliant human beings. In today’s dynamic world, development and grooming is of supreme importance and through our campus we are creating an environment for future leaders, entrepreneurs and professionals who possess skills and aptitudes in an array of functional disciplines.</p>
              <p>I am very happy with the progress the School has made by imbibing in its students value based education to produce a generation of well informed and emotionally sound generation. I am positive that in times to come we will continue this journey with elevated enthusiasm and persistently provide a platform of holistic learning to the young generation of learners.</p>   
              <p> We spare no efforts to make the educational experience of our students meaningful and relevant to the socio-economic needs of the times &amp; to equip our youth to face the challenges of the future for leading the society from the front, while ensuring that at the same time they are enjoying their experience of learning. A very competent team of teachers strive to focus on each and every child, monitor and mentor them, appreciate their achievement and encourage them to overcome their shortcomings. Our dynamic and enthusiastic Principal Mr.T T Thomas urge all the teachers to create appropriate, meaningful learning situations, inculcating life skills in the impressionable children and appreciating their smallest efforts with all generosity and broadness of vision. We crossed another milestone of excellence in its journey towards progress with the beginning of Mercy Memorial Alumni Association with a goal to mould the Impressionable mind, a sound genius of a citizen fully responsible and imbibed with our rich heritage of ideology and culture ready to serve the community and meet the challenges of the outside world. Beside academics, students are also encouraged to take part in extra curricular and co-curricular activities and the students have brought laurels to the institution. It has always been our belief that every student has an unending pool of talent that needs to be nurtured and which when guided with proper care and the correct attitude, can help bring out the best from any individual.</p>
              <p>Our school organises an array of events and activities like inter school cultural competitions, theme based assemblies, sports meets, basketball tournament, excursions...the list is long and the enthusiasm for everything is endless. I take immense pride in acknowledging the team-work and efforts of all students and teachers.</p>
              <p>And as the cliché goes, last but not the least, I expect all my young Mercians to focus on their cherished goals and strive hard to accomplish them transcending mediocrity and procrastination.
      </p>
              <p className="name">
                  Name  <span>  Vice Principal </span>
              </p>
            </div>
          )}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default VicePrincipal;
